<template>
    <div style="min-height: 150px">
        <VChart v-if="!state.loading" :option="chart" />
        <Spinner v-else></Spinner>
    </div>
</template>

<script lang="ts" config>
    import { onMounted, ref, watch, ChartData, setChartOption, Spinner, reactive } from "@/BaseComponent";
    import { use } from "echarts/core";
    import { EChartsOption } from "echarts";
    import {
        TitleComponent,
        TooltipComponent,
        LegendComponent,
        ToolboxComponent,
        GridComponent,
        DataZoomComponent,
        GraphicComponent,
    } from "echarts/components";
    import { CanvasRenderer } from "echarts/renderers";
    import { LineChart, BarChart, PieChart, CandlestickChart, GraphChart } from "echarts/charts";
    import VChart from "vue-echarts";
    import "echarts-wordcloud";

    export default {
        props: ["data", "defaultLayout"],
        components: {
            VChart,
            Spinner,
        },
        setup(props: any) {
            const chart = ref<EChartsOption>();
            const loading = ref<boolean>(true);
            const state = reactive({
                loading: true as boolean,
            });

            onMounted(() => {
                state.loading = true;
                setData(props.data);
            });

            watch(
                () => props.data,
                (newValue) => {
                    state.loading = true;
                    setData(newValue);
                },
                { deep: true },
            );

            const setData = async (data: ChartData) => {
                chart.value = setChartOption(props.defaultLayout, data);

                setTimeout(() => {
                    state.loading = false;
                }, 1000);
            };

            use([
                TitleComponent,
                TooltipComponent,
                LegendComponent,
                ToolboxComponent,
                GridComponent,
                GraphicComponent,
                CanvasRenderer,
                LineChart,
                BarChart,
                PieChart,
                GraphChart,
                CandlestickChart,
                DataZoomComponent,
            ]);

            return {
                chart,
                loading,
                state,
                props,
            };
        },
    };
</script>
